<template>
  <base-modal
    class="app-container rejoin-modal "
    no-footer
    ui-refresh
    @close-modal-clicked="dismissRejoinModal()">
    <template #title>
      <h2 class="text-orchid">
        Our Closet Is Your Closet.
      </h2>
      <p class="subtitle">
        Rejoin now and start renting again - new styles are waiting.
      </p>
    </template>
    <template #body>
      <div class="membership">
        <BaseRadios
          v-model="selectedId"
          class="vertical-radios"
          sequin
          :options="options"
          :name="'membership-plan'">
          <template #label>
            <h4 class="text-center">
              Renew Your Membership
            </h4>
          </template>
        </BaseRadios>
        <BaseButton
          text="Rejoin Today"
          @click="beginRejoinFlow(selectedId)"/>
      </div>
    </template>
  </base-modal>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import BaseModal from '@/components/global/BaseModal.vue'
import BaseRadios from '@/components/global/BaseRadios.vue'
import BaseButton from '@shared/components/ADORN/BaseButton.vue'
import { useSubscriptionStore } from '@/stores/subscribe.js'
import { useRejoinStore } from '@/stores/rejoin.js'

const { beginRejoinFlow, dismissRejoinModal } = useRejoinStore()
const { membershipPlans } = storeToRefs(useSubscriptionStore())
const { latestSubscriptionPlanId } = storeToRefs(useRejoinStore())

const selectedId = ref(latestSubscriptionPlanId.value)

const options = computed(() => {
  return membershipPlans.value?.filter((plan) => {
    return !plan.prepayment // Filter out prepayment plans
  }).map((plan) => {
    const price = plan.basePrice / 100
    let text = `${plan.displayName} $${price}/month`
    if (plan.id === latestSubscriptionPlanId.value) {
      text += ' (Previous Plan)' // Add a note for the previous plan
    }
    return {
      name: plan.displayName,
      text: text,
      value: plan.id
    }
  })
})

</script>
<style lang="scss" scoped>
.rejoin-modal {
  :deep(.modal-dialog) {
    margin: 0 auto !important;
    @include media-tablet-or-larger {
      max-width: 606px !important;
    }
  }
}
:deep(.modal-content) {
  background: $origami;
  padding: 48px 0px;
}
.vertical-radios {
  :deep(.regular-radios) {
    display: flex;
    flex-direction: column;
  }
  :deep(.sequin-radio) {
    .sequin-radio-label{
      &-active {
        color: $orchid !important;
      }
    }
  }
}
.membership {
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  border-radius: 2px;
  border: 3px solid $orchid;
  background: $white;
  margin: auto;
  @include media-tablet-or-larger {
      max-width: 433px !important;
  }
}
</style>
